import { render } from "./ChannelSubscriptionEnd.vue?vue&type=template&id=8b30d8aa"
import script from "./ChannelSubscriptionEnd.vue?vue&type=script&lang=ts"
export * from "./ChannelSubscriptionEnd.vue?vue&type=script&lang=ts"
script.render = render

export default script